<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.ticket_list_processed") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-4.col-lg-3.col-3.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                      span {{ $t('ui.operator') }}
                  DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_operator')" @enter="getTicketList(true)" size="sm")
              template(v-if="operatorID != ''")
                .form-group.col-md-4.col-lg-3.col-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" @enter="getTicketList(true)" size="sm")
              .form-group.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList(true)"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="ticketProcessedList.length > 0" mode="TicketListProcessedFcp" tbl="tblTicket" :date="dateRange" btnTxt="export_one").mr-2
                jsonToExcelFull(v-if="ticketProcessedListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="TicketListProcessedFcp" tbl="tblTicketFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2").mr-2
                ticketListProcessedFcpExport(v-if="ticketProcessedList.length > 0" :tbl="ticketProcessedList" tblId="tblTicket" :totalTbl="grandTotalAmount").mr-2
                ticketListProcessedFcpExportFull(v-if="ticketProcessedListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="ticketProcessedListFull" tblId="tblTicketFull" :totalTbl="grandTotalAmount")

          .card-body
            .row
              .col-12
                .card.mb-0
                  .card-body
                    .row
                      .col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="tplTotalRow"
                          :per-page="getPageSize"
                          v-model="currentTplPage"
                          @input="changedTplPage($event)").mb-1
                      .col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedTplPageSize" size="sm")
                      .col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="5%")
                                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                th(width="8%" v-if="!isOperator")
                                  span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                //- th(width="8%")
                                //-   span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                th.text-left(width="11%" @click="sortOrder('account_id')")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                  .float-right
                                    i(:class="changeSortKey('account_id')")
                                th.text-right(width="8%")
                                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                th.text-right(width="10%")
                                  span(:title="$t('ui.approve_time')") {{ $t("ui.approve_time") }}
                                th.text-right(width="10%")
                                  span(:title="$t('ui.audit_time_created')") {{ $t("ui.audit_time_created") }}
                            tbody.clusterize-content
                              tr(v-if="ticketProcessedList.length == 0")
                                td(colspan="14").text-center
                                  span {{ $t('message.no_data_available') }}
                              tr(v-for="(item, index) in ticketProcessedList" :class="$helpers.rowClassTicket(item, 'withdrawal')")
                                td.text-center
                                  span(:title="((currentTplPage - 1) * getPageSize + index + 1)") {{ ((currentTplPage - 1) * getPageSize + index + 1) }}
                                td
                                  span.d-block(:title="item.id") {{ item.id }}
                                  span.small.text-info.d-block(:title="getRefNo(item.sender_bank_id, item.id, item.prefix_fc, item.prefix_delimiter)") {{ getRefNo(item.sender_bank_id, item.id, item.prefix_fc, item.prefix_delimiter) }}
                                td(v-if="!isOperator")
                                  span(:title="item.operator_id") {{ item.operator_id }}
                                td
                                  span.font-weight-bold(:title="item.account_id")
                                    b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.account_id }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                td.text-right
                                  span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                                td.text-right
                                  span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
                              tr(v-if="showTotal")
                                td.text-right(:colspan="!isOperator ? 4 : 3")
                                  span {{ $t("ui.sub_total") }}
                                  br
                                  span {{ $t("ui.grand_total") }}
                                td.text-right
                                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
                                  br
                                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
                                td(colspan="3")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketdetail from "@/components/ticket/ticketDetail.vue";
import rejectapprovedticket from "@/components/ticket/rejectApprovedTicket.vue";
import DateRangePicker from "@/library/DateRangePicker.vue";
import rollbackprocessingticket from "@/components/ticket/rollbackProcessingTicket.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";
import ticketListProcessedFcpExport from "@/components/freecreditprovider/ticketListProcessedFcpExportFull.vue";
import ticketListProcessedFcpExportFull from "@/components/freecreditprovider/ticketListProcessedFcpExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketdetail,
    rejectapprovedticket,
    DateRangePicker,
    rollbackprocessingticket,
    jsonToExcelFull,
    jsonToExcel,
    ticketListProcessedFcpExport,
    ticketListProcessedFcpExportFull,
  },
  data: () => ({
    loading2: false,
    loading: false,
    ticketProcessedListFull: [],
    ticketProcessedList: [],
    currentTplPage: 1,
    tplTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    operatorID: "",
    memberID: "",
    sortKey: "account_id",
    sortType: "desc",
    showTotal: false,
    subTotalAmount: 0,
    grandTotalAmount: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    if(this.isOperator) {
      this.operatorID = this.accountID
      this.getTicketList(true);
    }
  },
  methods: {
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getTicketList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    resetInput() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    },
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getTicketList(true);
    },
    getTicketList(isSearch) {
      if (this.checkDateRange()) {
        this.getTicketProcessedList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getTicketProcessedListFull(isSearch);
        }
      } else {
        this.ticketProcessedList = [];
        this.ticketProcessedListFull = [];
        this.tplTotalRow = 0;
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    onInfo(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.operator_id);
      this.$router.push("/account/operator");
    },
    getTicketProcessedListFull: function(isSearch) {
      let url = config.ticketProcessedListFreeUrl();

      if (isSearch) this.currentTplPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        operator_id: this.operatorID,
        member_id: this.memberID,
        page_number: this.currentTplPage,
        page_size: -1,
        sort_key: this.sortKey,
        sort_type: this.sortType,
      };

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketProcessedListFull = response.data.dt;
                if(response.data.dt.length > 0) {
                  this.grandTotalAmount = response.data.dt[0]["total_amount"];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketProcessedList: function(isSearch) {
      let url = config.ticketProcessedListFreeUrl();

      if (isSearch) this.currentTplPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        operator_id: this.operatorID,
        member_id: this.memberID,
        page_number: this.currentTplPage,
        page_size: this.getPageSize,
        sort_key: this.sortKey,
        sort_type: this.sortType,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.clearTotal()
                  this.showTotal = true;
                  response.data.dt.forEach(value => {
                    this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["amount"]);
                  });

                  this.grandTotalAmount = response.data.dt[0]["total_amount"];
                  this.ticketProcessedList = response.data.dt;
                  this.tplTotalRow = this.ticketProcessedList.length > 0 ? this.ticketProcessedList[0].totalrows : 0;
                } else {
                  this.clearTotal()
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            // console.log(error)
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false
      this.ticketProcessedList = []
      this.tplTotalRow = 0
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    changedTplPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentTplPage = 1;
      this.getTicketProcessedList(true);
    },
    changedTplPage: function(pageNo) {
      this.currentTplPage = pageNo;
      this.getTicketProcessedList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>